<template>
  <div
    v-if="liffSetting"
    id="app"
    class="app-main-sty container-fluid"
    >
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<style lang="scss">
@import "~@/assets/scss/vendors/bootstrap-vue/index";
@import "~@/assets/scss/vendors/index";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  async created () {
    await this.getUrlInfo()
    this.liffSetting = true
  },
  data () {
    return {
      isRouterAlive: true,
      userType: null,
      liffSetting: false
    }
  },
  beforeCreate () {
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    async getUrlInfo () {
      const currentFpt = this.$route.fullPath
      var tranPtArray = currentFpt.split('/').slice(1) // eg. ['staff', 'order', 'create']
      var caseIdArray = []
      var routeInfo = {}
      var currentLiffID = null
      routeInfo.type = tranPtArray[0].includes('?') ? tranPtArray[0].split('?').shift() : tranPtArray[0]
      routeInfo.category = tranPtArray[1]
      if (tranPtArray[2]) {
        tranPtArray[2] = tranPtArray[2].includes('?v') ? tranPtArray[2].split('?v').shift() : tranPtArray[2]
      }
      if (tranPtArray[2] && tranPtArray[2].includes('#')) {
        caseIdArray = tranPtArray[2].split('#')
        routeInfo.case = caseIdArray[0]
        routeInfo.id = caseIdArray[1]
      } else {
        routeInfo.case = tranPtArray[2]
      }
      this.$store.dispatch('setRouteInfo', routeInfo)
      switch (routeInfo.type) {
        case 'customer':
          currentLiffID = this.$liffDoc.customerLiffID
          this.userType = 'customer'
          break
        case 'staff':
          currentLiffID = this.$liffDoc.staffLiffID
          this.userType = 'staff'
          break
        case 'staffs':
          currentLiffID = this.$liffDoc.staffLiffID
          this.userType = 'staff'
          break
      }

      if (process.env.NODE_ENV === 'development') {
        console.log(currentLiffID)
        console.log('userType', this.userType)
      }

      try {
        await this.$liff.init({ liffId: currentLiffID })
        console.log('Liff init ok', currentLiffID)

        await this.getLiffProfile()
      } catch (error) {
        console.warn('Liff init error:', error)
        this.$liff.closeWindow()
      }
    },
    async getLiffProfile () {
      var profile = null

      // For test
      if (process.env.VUE_APP_ANDY) {
        console.log('testing for andy')
        profile = {
          // userId: 'Ua299e95bd28ca138d2656260b43dd458', // Annz
          userId: 'Ueccf1bb1e5b34001a4bef516259bce0f', // Andy
          displayName: '王小明',
          pictureUrl: ''
        }

        this.$store.dispatch('setLineUserId', profile.userId)
        this.$store.dispatch('setLineProfile', profile)
        return
      }

      try {
        profile = await this.$liff.getProfile()
        this.$store.dispatch('setLineUserId', profile.userId)
        this.$store.dispatch('setLineProfile', profile)
        this.updateLineProfile(profile)
      } catch (error) {
        console.warn('Liff getProfile error:', error)
      }
    },
    updateLineProfile (profile) {
      const baseUrl = this.userType === 'customer' ? this.$apiDoc.updateUserProfile : this.$apiDoc.staffUrl
      var finalUrl = baseUrl
      var isError = true
      var userId = ''
      var displayName = ''
      var pictureUrl = ''
      var opstions = {}
      if (profile) {
        userId = profile.userId
        displayName = profile.displayName
        pictureUrl = profile.pictureUrl
        opstions.pictureUrl = pictureUrl
        finalUrl += userId + this.$apiDoc.updateLineProfile
        if (this.userType === 'customer') {
          opstions.displayName = displayName
        }
        this.$api.patch(finalUrl, opstions).then((resp) => {
          if (resp.result) {
            isError = false
          }
          if (isError) {
            console.warn('Profile update  error:', resp)
          }
        }).catch((errorInfo) => {
          console.warn('Profile update  error:', errorInfo, errorInfo.response)
        })
      }
    }
  }
}
</script>
